import React from 'react';

const ErrorPage = () => {
    return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
            <h1>Something went wrong</h1>
            <p>We apologize, but an unexpected error occurred.</p>
            <a href="/family-and-friends">Go back to the homepage</a>
        </div>
    );
};

export default ErrorPage;
